import { render } from "./UserInsights.vue?vue&type=template&id=6cd0af3a&scoped=true&ts=true"
import script from "./UserInsights.vue?vue&type=script&lang=ts"
export * from "./UserInsights.vue?vue&type=script&lang=ts"

import "./UserInsights.vue?vue&type=style&index=0&id=6cd0af3a&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd0af3a"]])

export default __exports__